import React, { FC } from 'react';
import { InputBase, IInputBaseProps } from '@hox/ui/InputBase';

export interface IInputProps extends IInputBaseProps {}

export const Input: FC<IInputBaseProps> = props => (
  <InputBase {...props} as="input" />
);
